module.exports = __webpack_public_path__ + "static/img/4.b3ca1d15.png";